<template>
  <v-app>
    <navigation-drawer width="212" class="d-print-none" :drawer="drawer" :loaded="loaded"></navigation-drawer>
    <plugin-confirm-dialog class="d-print-none" />
    <main-toolbar class="d-print-none" v-if="!simpleLayout" @toggle-drawer="toggleDrawer($event)" />
    <v-main class="d-print-none">
      <plugin-alert />
      <plugin-loading />
      <confirm ref="confirm" />
      <plugin-loading-count />
      <v-container
        id="container"
        fluid
        grid-list-xl
        class="overflow-auto pa-0 pa-sm-2 pa-md-2 pa-xl-2 pa-lg-2"
        :style="{ height: `calc(100vh - 64px)` }"
        style="overflow-x: hidden; background-color: #fafafa"
      >
        <router-view v-if="loaded" />
        <div v-else>
          <v-skeleton-loader type="card-avatar, article, actions"></v-skeleton-loader>
        </div>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import MainToolbar from './MainToolbar'
import PluginConfirmDialog from '@/components/plugin/PluginConfirmDialog'
import PluginAlert from '@/components/plugin/PluginAlert'
import PluginLoading from '@/components/plugin/PluginLoading'
import PluginLoadingCount from '@/components/plugin/PluginLoadingCount'
import Confirm from '@/components/plugin/Confirm'
import NavigationDrawer from '@/components/layout/NavigationDrawer.vue'
export default {
  components: {
    MainToolbar,
    PluginConfirmDialog,
    PluginAlert,
    PluginLoading,
    Confirm,
    NavigationDrawer,
    PluginLoadingCount
  },
  data() {
    return {
      drawer: true,
      loaded: false,
      messageGroupParams: {}
    }
  },
  computed: {
    ...mapState('auth', ['isAuthenticated']),
    ...mapGetters('auth', ['user', 'role', 'profile']),
    simpleLayout() {
      const { meta = {}, matched = [] } = this.$route
      return meta.auth === false || matched.some(route => route.meta.auth === false)
    },
    isDesktop() {
      return true
    }
  },
  async created() {
    if (this.isAuthenticated) {
      this.loaded = false
      // Fetch user profile data
      const promises = [this.fetchRoles(), this.fetchSchoolSettings()]
      if (this.role.type === 'teacher') {
        promises.push(this.fetchTeacher({ user: this.user.id }))
      } else {
        promises.push(this.fetchStaff({ user: this.user.id }))
      }
      try {
        await Promise.all(promises)
      } catch (error) {
        console.error(error)
      }
      this.loaded = true
      // kiểm tra với phần phí thì ko gọi message vì load lâu
      if (!this.$route.fullPath.includes('fee')) {
        await this.checkHasNewMessage()
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  methods: {
    ...mapActions('app', ['fetchSchoolSettings', 'checkUnReadMessage']),
    ...mapActions('role', ['fetchRoles']),
    ...mapActions('course', ['fetchCourses']),
    ...mapActions('auth', ['fetchStaff', 'fetchTeacher']),
    toggleDrawer: function(updatedDrawer) {
      this.drawer = updatedDrawer
    },
    async checkHasNewMessage() {
      if (this.role.type === 'teacher') {
        this.messageGroupParams = {
          type: 'teacher'
        }
        // chi lay nhom chat lop dang chu nhiem
        if (this.profile.ownClasses && this.profile.ownClasses.length) {
          const ownClassIds = this.profile.ownClasses.map(c => c.id)
          this.messageGroupParams['class_in'] = ownClassIds
        } else {
          this.messageGroupParams = null
        }
      } else {
        this.messageGroupParams = {
          type: 'manager'
        }
      }
      if (this.messageGroupParams) {
        await this.checkUnReadMessage(this.messageGroupParams)
      }
      this.interval = setInterval(async () => {
        if (this.messageGroupParams && this.isAuthenticated) {
          await this.checkUnReadMessage(this.messageGroupParams)
        }
      }, 600000)
    }
  }
}
</script>
